var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "republic-of-poland",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_174",
    "data-name": "Ellipse 174",
    cx: 14.912,
    cy: 14.891,
    rx: 14.912,
    ry: 14.891,
    transform: "translate(-0.001 0)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    "data-name": "Path 2416",
    d: "M29.744,256a15,15,0,0,1-14.872,15.116A15,15,0,0,1,0,256",
    transform: "translate(0.255 -241.116)",
    fill: "#d80027"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPl);
export default __webpack_public_path__ + "static/media/PL.bb5eff946554138fbd3b0a38f6a5b1c4.svg";
export { ForwardRef as ReactComponent };